<template>
  <div>
	 <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Add Role</strong>
          </CCardHeader>
          <CCardBody>
			<CForm class="formData">
            <CRow>
				<CCol sm="12">
                <CInput
                  label="Role Name"
                  placeholder="Role Name"
                  name="RoleName"
                  id="RoleName"
                />
              </CCol>
            </CRow>
            <!-- <CRow>
                <template v-for="(name, key) in checkboxNames">
                <CRow sm="12" form class="form-group" :key="name">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{name}}
                  </CCol>
                  <CCol sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <CInputCheckbox
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
                      :checked="optionIndex === key"
                      :inline="key % 2 === 1"
                    />
                  </CCol>
                </CRow>
              </template>
            </CRow> -->
           
            <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Add</button>
			</CCol>
			 
            </CRow>
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Add_roles',
  data () {
    return {
      isLoading: false,
      setSelected:"",
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },      
	  siteOptions : [],
      physicalOptions : ['New physical','LIQUID'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,
	  
      formCollapsed: true,
      checkboxNames: ['Change Status'],
	  options: ['role-list', 'role-create', 'role-edit', 'role-delete', 'deshboard-transactions-chart'],     
	  
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],			
    }
  },
  mounted () {
	$('.counterDiv').hide();
	$('.otherOptions').hide();	
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){		
		this.$router.push({path:'role_lists'})
	},
	submit(){			
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		// var Role_Name=JSON.parse(localStorage.getItem("RoleName"));	
		var RoleName=$('input[name=RoleName]').val();		
			if(RoleName==''){
				this.$swal('Role Name is required');
        return false;
      }
		// 	}else if(RoleName==Role_Name){
		// 		this.$swal('Role Name already exists');
		// 		return false;
		// }
		var user=JSON.parse(localStorage.getItem("user"));
		var FirstName=user[0].FirstName;		
		var LastName=user[0].LastName;	
		var token=localStorage.getItem("auth");
		
		var requestInfo = {
		  RoleName: RoleName,
		  GuardName: FirstName+' '+LastName,
		  Status: 'Active',
		  Token:token,
		  Session_User_Id:Session_User_Id,
		};		
		var self =this;

		var data = JSON.stringify(requestInfo);					
			var config = {
			  method: 'post',
			  url: apiURL+'ManageRole/AddNewRole',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		  };
    this.isLoading = true;
		axios(config)
		.then((result) => {
      this.isLoading = false;
			//console.log(config);	
			if(result.data.status_code==200){				
				this.$swal.fire(
					'Saved',
					result.data.message,
					'success'
				);
				$('.formData')[0].reset();
			}else{									
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {	
      this.isLoading = false;				  
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	}
  }
}
</script>
